import { createSlice } from "@reduxjs/toolkit";
import {
  createHomeWorkThunk,
  createProjectThunk,
  createRemarksThunk,
  fetchTeacherHomework,
  getAllTopicsThunk,
  getHomeWorkByFiltersThunk,
  getProjectByIdentifiersThunk,
  getRemarksByIdentifiers,
  getTopicByIdentifiers,
  postTopic,
  updateHomeWorkThunk,
  updateProjectThunk,
  updateRemarksThunk,
  updateTopicThunk,
  updateTopicStatusThunk,
} from "./topicReducer";

const initialState = {
  popupInfo: null,
  isOpen: false,
  loading: false,
  error: null,
  existingTopic: null,
  isRemark: false,
  isProject: false,
  isHomeWork: false,
  existingRemarks: [],
  projectData: [],
  existingHomework: [],
  allTopics: [],
  HwData: [],
};

const topicSlice = createSlice({
  name: "topic",
  initialState,
  reducers: {
    setPopupInfo: (state, action) => {
      state.popupInfo = action.payload;
      console.log("state.popupInfo", state.popupInfo);
      state.isOpen = true;
    },
    clearPopupInfo: (state) => {
      state.popupInfo = null;
      state.isOpen = false;
      state.existingTopic = null;
    },
    setRemarksPopup: (state, action) => {
      state.popupInfo = action.payload;
      state.isRemark = true;
    },
    closeRemarksPopup: (state) => {
      state.isRemark = false;
      state.popupInfo = null;
    },
    setProjectsPopup: (state, action) => {
      state.popupInfo = action.payload;
      state.isProject = true;
    },
    closeProjectPopup: (state) => {
      state.isProject = false;
      state.popupInfo = null;
      state.projectData = [];
    },
    setHwPopup: (state, action) => {
      state.popupInfo = action.payload;
      state.isHomeWork = true;
    },
    closeHwPopup: (state) => {
      state.isHomeWork = false;
      state.popupInfo = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postTopic.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postTopic.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(postTopic.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTopicByIdentifiers.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.existingTopic = null;
      })
      .addCase(getTopicByIdentifiers.fulfilled, (state, action) => {
        state.loading = false;
        state.existingTopic = action.payload;
      })
      .addCase(getTopicByIdentifiers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateTopicThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTopicThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTopicThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createRemarksThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createRemarksThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(createRemarksThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to create remarks";
      })
      .addCase(getRemarksByIdentifiers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRemarksByIdentifiers.fulfilled, (state, action) => {
        state.loading = false;
        state.existingRemarks = action.payload;
      })
      .addCase(getRemarksByIdentifiers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.existingRemarks = [];
      })
      .addCase(updateRemarksThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRemarksThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateRemarksThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createProjectThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createProjectThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createProjectThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getProjectByIdentifiersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.projectData = null;
      })
      .addCase(getProjectByIdentifiersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.projectData = action.payload;
      })
      .addCase(getProjectByIdentifiersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch project";
      })
      .addCase(updateProjectThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProjectThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateProjectThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch project";
      })
      .addCase(getHomeWorkByFiltersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHomeWorkByFiltersThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.existingHomework = action.payload;
      })
      .addCase(getHomeWorkByFiltersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createHomeWorkThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createHomeWorkThunk.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createHomeWorkThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateHomeWorkThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHomeWorkThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateHomeWorkThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllTopicsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTopicsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.allTopics = action.payload;
      })
      .addCase(getAllTopicsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch topics";
      })
      .addCase(fetchTeacherHomework.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherHomework.fulfilled, (state, action) => {
        state.loading = false;
        state.HwData = action.payload;
      })
      .addCase(fetchTeacherHomework.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTopicStatusThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTopicStatusThunk.fulfilled, (state, action) => {
        state.loading = false;

        // Update status directly in allTopics
        const updated = action.meta.arg;
        // action.meta.arg contains the payload you sent

        const index = state.allTopics.findIndex((topic) =>
          topic.class_id == updated.class_id &&
          topic.section_id == updated.section_id &&
          topic.subject_id == updated.subject_id &&
          topic.period_number == updated.period_number &&
          topic.chapter_name == updated.chapter_name
        );

        if (index !== -1) {
          state.allTopics[index].status = String(updated.status);
        }
      })
      .addCase(updateTopicStatusThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to update topic status";
      })
  },
});

export const {
  setPopupInfo,
  clearPopupInfo,
  setRemarksPopup,
  closeRemarksPopup,
  setProjectsPopup,
  closeProjectPopup,
  setHwPopup,
  closeHwPopup,
} = topicSlice.actions;
export default topicSlice.reducer;
